import React from 'react'
import { connect } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { Box } from '@mui/material'
import { retrieveJoin, retrieveScoreBackup } from '../lib/dexie'
import { sendWs, JOIN, REJOIN } from '../lib/send'
import { rxEnterRoom, rxJoin } from '../lib/rx_subject'
import store from '../redux/store'
import { reset } from '../redux/actions/main'
import Grid from './Grid'
import EnterRoom from './EnterRoom'
import CommonDialogs from '../dialogs/Dialogs'

const joinRoom = async roomNo => {
  const { rooms } = store.getState()
  rxEnterRoom.next(rooms[roomNo - 1])
  const join = await retrieveJoin()
  if (join) {
    sendWs(REJOIN, join)
  }
}

const Root = ({ rooms }) => {
  const location = useLocation()
  const navigate = useNavigate()

  const enterRoom = async join => {
    join.scoreBackup = await retrieveScoreBackup(join.name)
    sendWs(JOIN, join)
  }

  React.useEffect(() => { document.title = 'Yqui | TOP' }, [])

  React.useEffect(() => { store.dispatch(reset()) }, [])

  React.useEffect(() => {
    const state = location.state
    if (state && state.roomNo) {
      joinRoom(state.roomNo)
    }
  }, [location.state])

  React.useEffect(() => {
    const subscription = rxJoin.subscribe(roomNo => {
      navigate(`/room/${roomNo}`)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [navigate])

  return (
    <Box className="rooms">
      <Grid />
      <EnterRoom submit={enterRoom} />
      <CommonDialogs />
    </Box>
  )
}

export default connect(
  state => ({
    rooms: state.rooms
  })
)(Root)
